
export default {
	list: 'Allocation',
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		InvestmentId: {
			class: "lookup",
			dataName: 'InvestmentId',
			type: 'number',
			title: 'Investment Id',
			width: 100,
			hidden: false,
			readOnly: false
		},
		InvestmentInvestmentID: {
			class: "lookup",
			dataName: 'Investment/InvestmentID',
			type: 'string',
			title: 'Investment ID',
			width: 100,
			hidden: false,
			readOnly: true
		},
		InvestmentTitle: {
			class: "lookup",
			dataName: 'Investment/Title',
			type: 'string',
			title: 'Investment Name',
			width: 100,
			hidden: false,
			readOnly: true
		},
		PartnerId: {
			class: "lookup",
			dataName: 'PartnerId',
			type: 'number',
			title: 'Partner Id',
			width: 100,
			hidden: false,
			readOnly: false
		},
		PartnerPartnerID: {
			class: "lookup",
			dataName: 'Partner/PartnerID',
			type: 'string',
			title: 'Partner ID',
			width: 100,
			hidden: false,
			readOnly: true
		},
		PartnerFullName: {
			class: "lookup",
			dataName: 'Partner/FullName',
			type: 'string',
			title: 'Partner Name',
			width: 100,
			hidden: false,
			readOnly: true
		},
		TaxYear: {
			class: "choice",
			dataName: 'TaxYear',
			type: 'string',
			title: 'Tax Year',
			width: 100,
			hidden: false,
			readOnly: false
		},
		TaxQuarter: {
			class: "choice",
			dataName: 'TaxQuarter',
			type: 'string',
			title: 'Tax Quarter',
			width: 100,
			hidden: false,
			readOnly: false
		},
		//made readonly as "false" to write to DB.json to test in local 
		//Although Calculated field Works with SP also 
		TaxYearQuarter: {
			class: "value",
			dataName: 'TaxYearQuarter',
			type: 'string',
			title: 'Tax Period',
			width: 100,
			hidden: false,
			readOnly: false
		},
		ProjectedValue: {
			class: "value",
			dataName: 'ProjectedValue',
			type: 'number',
			title: 'Projected Value',
			width: 100,
			hidden: false,
			readOnly: false
		},
		CurrentValue: {
			class: "value",
			dataName: 'CurrentValue',
			type: 'number',
			title: 'Current Value',
			width: 100,
			hidden: false,
			readOnly: false
		},
		Percentage: {
			class: "value",
			dataName: 'Percentage',
			type: 'number',
			title: 'Percentage',
			width: 100,
			hidden: false,
			readOnly: false
		},
		UnitType: {
			class: "value",
			dataName: 'UnitType',
			type: 'string',
			title: 'UnitType',
			width: 100,
			hidden: false,
			readOnly: false
		},
		UnitClass: {
			class: "value",
			dataName: 'UnitClass',
			type: 'string',
			title: 'UnitClass',
			width: 100,
			hidden: false,
			readOnly: false
		},
		VestingType: {
			class: 'choice',
			dataName: 'VestingType',
			type: 'string',
			title: 'Vesting Type',
			width: 150,
			hidden: false,
			readOnly: false
		},
	},
}